import { BUSINESS_UNIT } from '../constants/omp';

const getSelectedDealerId = (dealerships, selectedDealership) =>
  dealerships
    ?.find(dealership => dealership.organizationId === selectedDealership)
    ?.sourceInfo?.find(source => source.businessUnit === BUSINESS_UNIT.TRADEREV)
    ?.sourceId;

export default getSelectedDealerId;
